// components/FitnessStatsChart.js
import React from "react"
import ReactApexChart from "react-apexcharts"
import moment from "moment"

// ⏱ Convert duration string → total seconds
const durationToSeconds = duration => {
  if (!duration) return 0
  const [hours, minutes] = duration.split(":").map(Number)
  return (hours || 0) * 3600 + (minutes || 0) * 60
}

// ⏰ Format seconds → HH:MM:SS
const formatSeconds = seconds => {
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = Math.floor(seconds % 60)
  return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:${s
    .toString()
    .padStart(2, "0")}`
}

const FitnessStatsChart = ({ data, type = "duration" }) => {
  // Sort data by date
  const sortedData = [...(data || [])].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  )

  const durations =
    type === "distance"
      ? sortedData.map(item => Number(item?.distance) || 0)
      : sortedData.map(item => durationToSeconds(item?.duration))

  const chartOptions = {
    chart: {
      type: "line",
      zoom: { enabled: true },
      toolbar: { show: true },
    },
    xaxis: {
      categories: sortedData.map(item => moment(item.date).format("DD-MM")),
      axisTicks: { show: false },
      axisBorder: { show: false },
      title: {
        text: "Activity Dates",
        offsetY: 130,
      },
      range: 14, // show 10 points at a time
    },
    yaxis: {
      title: {
        text: type === "duration" ? "Duration (HH:MM:SS)" : "Distance (mi)",
      },
      labels: {
        formatter: val =>
          type === "duration" ? formatSeconds(val) : val.toFixed(1),
      },
    },
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    tooltip: {
      y: {
        formatter: val => (type === "duration" ? formatSeconds(val) : val),
      },
    },
  }

  const chartSeries = [
    {
      name: type === "duration" ? "Workout Duration" : "Distance",
      data: durations,
    },
  ]

  return (
    <div>
      <ReactApexChart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={250}
        width="100%"
      />
    </div>
  )
}

export default FitnessStatsChart
